module.exports = __webpack_public_path__ + "static/media/S (34).c77332a2.jpg";